module.exports = __webpack_public_path__ + "img/industry4.121db30a.jpg";